import {
  Box,
  Typography,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
  Alert,
} from "@mui/material";
import Header from "../../../components/Header";
import SetupGuide from "../../../../src/components/SetupGuide";
const TokenGatingInfo = ({
  register,
  errors,
  onHandleNftTokenGatingInputChange,
  nftTokenGatingInputFields,
  onHandleInputChangeForPageBased,
  pageBasedTokenGatingData,
  handleRemoveClick,
  handleAddClick,
  handleClearDataForPageBased,
}) => {
  return (
    <Box mt="40px" ml="70px">
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Header
          title="Token Gating Configuration"
          subtitle="Provide Token Gating configuration"
        />
        <SetupGuide url={process.env.REACT_APP_GENERAL_SETUP_GUIDE} />
      </Box>
      <Grid container spacing={2}>
        <Grid item md={12} sm={12} xs={12}>
          <FormControl sx={{ boxShadow: 2 }} fullWidth required>
            <InputLabel id="demo-simple-select-label">Token Gating</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="isFullSiteOrPageBasedTokenGating"
              label="Token Gating"
              onChange={onHandleNftTokenGatingInputChange}
              value={nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating}
            >
              <MenuItem
                value={"Full Site"}
                onClick={() => handleClearDataForPageBased()}
              >
                Full site Token Gating
              </MenuItem>
              <MenuItem
                value={"Page Based"}
                onClick={() => handleClearDataForPageBased()}
              >
                Page Based Token Gating
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {(nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ===
          "Page Based" ||
          nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ===
            "Full Site") &&
          pageBasedTokenGatingData.map((currentElement, index) => {
            return (
              <Grid container key={index} direction="row">
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ mt: 2, ml: 2.3, boxShadow: 2 }}
                    fullWidth
                    name="pagePath"
                    label="page path"
                    variant="outlined"
                    type="text"
                    required
                    value={
                      nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ===
                      "Page Based"
                        ? currentElement.pagePath
                        : (currentElement.pagePath = "/")
                    }
                    disabled={
                      nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating ===
                      "Page Based"
                        ? false
                        : true
                    }
                    onChange={(event) =>
                      onHandleInputChangeForPageBased(event, index)
                    }
                  />
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <FormControl
                    sx={{ ml: 3, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                  >
                    <InputLabel id="demo-simple-select-label">
                      Select BlockChain
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="blockChain"
                      label="Select BlockChain"
                      value={currentElement.blockChain}
                      onChange={(event) =>
                        onHandleInputChangeForPageBased(event, index)
                      }
                    >
                      <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                      <MenuItem value={"Polygon"}>Polygon</MenuItem>
                      <MenuItem value={"POAP/xDai"}>POAP/xDAI</MenuItem>
                      <MenuItem value={"Sepolia-Ethereum"}>
                        Sepolia Ethereum
                      </MenuItem>
                      <MenuItem value={"Base-Mainnet"}>Base Mainnet</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <FormControl
                    sx={{ ml: 3.5, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                  >
                    <InputLabel id="demo-simple-select-label">
                      Token Standard
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="tokenStandard"
                      label="Enter Smart Contract Token Standard"
                      value={
                        currentElement.blockChain === "POAP/xDai"
                          ? (currentElement.tokenStandard = "ERC721")
                          : currentElement.tokenStandard
                      }
                      onChange={(event) =>
                        onHandleInputChangeForPageBased(event, index)
                      }
                      disabled={
                        currentElement.blockChain === "POAP/xDai" ? true : false
                      }
                    >
                      <MenuItem value={"ERC20"}>ERC20</MenuItem>
                      <MenuItem value={"ERC721"}>ERC721</MenuItem>
                      <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={1} xs={1} sm={1}>
                  {
                    <Button
                      className="custom-color-button"
                      disabled={
                        pageBasedTokenGatingData.length - 1 === index
                          ? false
                          : true
                      }
                      variant="contained"
                      sx={{ mt: 6, ml: 5 }}
                      onClick={handleAddClick}
                      color="info"
                    >
                      Add
                    </Button>
                  }
                </Grid>
                <Grid item md={1} xs={1} sm={1}>
                  {
                    <Button
                      disabled={
                        pageBasedTokenGatingData.length === 1 ? true : false
                      }
                      variant="contained"
                      sx={{ mt: 6, ml: 5, fontFamily: "Poppins" }}
                      onClick={() => handleRemoveClick(index)}
                      color="error"
                    >
                      Remove
                    </Button>
                  }
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 2.3, boxShadow: 2 }}
                    fullWidth
                    required
                    name="contractAddress"
                    label={
                      currentElement.blockChain === "POAP/xDai"
                        ? "Event ID"
                        : "Contract Address"
                    }
                    variant="outlined"
                    type="text"
                    id="contractAddress"
                    value={currentElement.contractAddress}
                    onChange={(event) =>
                      onHandleInputChangeForPageBased(event, index)
                    }
                  />
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 3, boxShadow: 2 }}
                    fullWidth
                    name="tokenId"
                    variant="outlined"
                    value={currentElement.tokenId}
                    label="Token Id"
                    type="text"
                    id="tokenId"
                    onChange={(event) =>
                      onHandleInputChangeForPageBased(event, index)
                    }
                  />
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 3.5, boxShadow: 2 }}
                    fullWidth
                    required
                    name="nftsRequired"
                    variant="outlined"
                    label="Nfts/Tokens Required"
                    inputProps={{ type: "number", min: 1 }}
                    id="nftsRequired"
                    value={currentElement.nftsRequired}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (value === "" || value > 0) {
                        onHandleInputChangeForPageBased(event, index);
                      }
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default TokenGatingInfo;
